import React from 'react';

import { CategoryDashboard } from '../modules/audience-category-dashboard';

const sortingOptions = [
    {
        label: 'Sort by: Name',
        value: 'name',
        direction: 'asc',
    },
    {
        label: 'Sort by: Newest',
        value: '_created',
        direction: 'desc',
    },
    {
        label: 'Sort by: Last Updated',
        value: 'lastRefreshed',
        direction: 'desc',
    },
];

const PersonasLayout = ({
    audienceSegments,
    onSearch,
    segmentCount,
    activeAudience,
    organizationId,
}) => {
    const linkToAudienceTab = {
        pathname: '/audiences/all',
        query: { audienceTab: 'pelmorex_data' },
        linkBackLabel: 'Pelmorex Data',
    };

    return (
        <CategoryDashboard
            audienceSegments={audienceSegments}
            onSearch={onSearch}
            segmentCount={segmentCount}
            activeAudience={activeAudience}
            organizationId={organizationId}
            sortingOptions={sortingOptions}
            description={
                'Combining demographic insights with behavioral analytics, these segments identify distinct consumer personas based on lifestyle characteristics and purchase patterns (eg., Tech Early Adopters, Luxury Spenders).'
            }
            title={'Personas'}
            linkToAudienceTab={linkToAudienceTab}
            bannerImagePath={'/images/audience-segments/banners/personas-banner.png'}
        />
    );
};

export default PersonasLayout;
